import type { EntitySelectorTriggerSize } from "@salestrak/ui";

// The selectors keep the app's field-control size scale ("xs"–"xl",
// FieldControlSize) at their public boundary; the particle trigger and Button
// run narrower scales, so these maps clamp at the boundary.
export type SelectorSize = "xs" | "sm" | "default" | "lg" | "xl";

export function toEntityTriggerSize(
  size: SelectorSize | undefined,
): EntitySelectorTriggerSize | undefined {
  switch (size) {
    case "xs":
    case "sm":
      return "sm";
    case "lg":
    case "xl":
      return "lg";
    case "default":
      return "default";
    default:
      return undefined;
  }
}
